module.exports = {
  fetch: `query getMonitorModels {
    monitorModels {
      id
      key
      label {
        en
        es
      }
      productTypes
    }
  }`,
};
